import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { Modal, Icon, Header, Divider } from 'semantic-ui-react';
import TargetLink from '../target-link';

const modalStyle = {
  textAlign: 'center',
  color: '#777',
};

const nameStyle = {
  marginTop: 10,
  marginBottom: 10,
  display: 'block',
};

const OrganisationBlock = ({
  organisationName,
}) => (
  <Modal
    open
    style={modalStyle}
    size="small"
  >
    <Modal.Content>
      <Header as="h2" icon>
        <Icon name="warning sign" color="orange" />
        <h2 style={nameStyle}>{organisationName}</h2>
        <Header.Subheader>
            Your subscription has expired.
            Please contact our Sales team to arrange access.
            You can use the support button in the bottom right of
            the screen or email us at <TargetLink renderIf href="mailto:sales@dyzio.co">sales@dyzio.co</TargetLink>.
          <Divider />
        </Header.Subheader>
      </Header>
    </Modal.Content>
  </Modal>
);

OrganisationBlock.propTypes = {
  organisationName: PropTypes.string.isRequired,
};

export default withRouter(OrganisationBlock);



/** WEBPACK FOOTER **
 ** ./src/components/organisation-block/index.js
 **/